export class ImeiLookupModel {
  imeimodalHeader: string;
  imeimodalHeader2: string;
  imeimodalMessage: string;
  imeiFieldLabel: string;
  imeilookupButtonMessage: string;
  imeicancelButtonMessage: string;

  constructor() {}
}
